// extracted by mini-css-extract-plugin
module.exports = {"switch":"AttributionSwitch_switch__3zyiv","align":"AttributionSwitch_align__2mZ-U"};